module.exports = __webpack_public_path__ + "img/sintesis.aaff048b.svg";